module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-bet-up@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-betmenu/btn-bet-up@2x.png
// module id = 621
// module chunks = 0